import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { REACT_APP_API_URL } from "../env";


const ReschedulePage = () => {
    const { bookingRefNo } = useParams();
    const [bookingDetails, setBookingDetails] = useState(null);
    const location = useLocation();
    const [rescheduleAllowed, setRescheduleAllowed] = useState(null);
    const [checkMessage, setCheckMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [rescheduleSubmitted, setRescheduleSubmitted] = useState(false);
    const [bookingError, setBookingError] = useState("");
    const newCheckInFromState = location.state?.newCheckIn || "";
    useEffect(() => {
        const fetchBookingDetails = async () => {
            try {
                const res = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/hotel/reschedule-booking`, {
                    bookingrefno: bookingRefNo,
                },{withCredentials:true});

                if (res.data.data && res.data.data.length > 0) {
                    setBookingDetails(res.data.data[0]);
                } else {
                    const message = res.data?.message || "Booking details not found.";
                    setBookingError(message);
                }
            } catch (error) {
                const message = error?.response?.data?.message || "Error fetching booking details.";
                console.error("Error fetching booking details:", error);
                setBookingError(message);
            }
        };

        fetchBookingDetails();
    }, [bookingRefNo]);

    const checkAccomodation = async (e) => {
        e.preventDefault();

        try {
            const res = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/confirm/reschedule-booking`, {
                bookingId: bookingDetails.BookingID,
                vchfDate: newCheckInFromState,
            },{withCredentials:true});
            const allowed = res.data.rescheduleAllowed;

            setRescheduleAllowed(allowed);
            if (allowed) {
                setCheckMessage(" Rooms are available for reschedule.");
            } else {
                setCheckMessage("Rooms are not available for reschedule.");
            }


        } catch (error) {
            const errorMsg = error?.response?.data?.message || "Failed to submit reschedule request.";
            console.error(errorMsg);
            setCheckMessage("Error checking availability");
            setRescheduleAllowed(false);
        }
        setLoading(false);
    };
    const handleSubmitReschedule = async () => {
        setSubmitting(true);
        try {
            const response = await axios.post(
                `${REACT_APP_API_URL}api/dashboard/admin/update/reschedule-booking`,
                {
                    bookingId: bookingDetails.BookingID,
                    vchfDate: newCheckInFromState,
                    bookingrefno: bookingRefNo,
                },{withCredentials:true}
            );
            

            if (response.data.message === "Booking rescheduled successfully.") {
                alert("Reschedule request submitted successfully.");
                setRescheduleSubmitted(true); // Disable button after success
            } else {
                alert("Failed to submit reschedule request.");
            }
        } catch (error) {
            console.error("Error submitting reschedule:", error);
            alert("Error while submitting reschedule request.");
        }
        setSubmitting(false);
    };


    if (bookingError) {
        return <div className="container mt-5"><p className="text-danger">{bookingError}</p></div>;
    }

    if (!bookingDetails) {
        return <div className="container mt-5"><p>Loading booking details...</p></div>;
    }

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-lg-12 col-md-11">

                    <div className="text-center mb-4">
                        <h2 className="fw-bold">Reschedule Booking</h2>
                        <p className="text-muted">Reference No: {bookingRefNo}</p>
                        <p>
                            <strong style={{ color: 'purple' }}>New Check-in Requested:</strong>{" "}
                            {newCheckInFromState ? new Date(newCheckInFromState).toLocaleDateString() : "N/A"}
                            {" "} BookingID: <strong>{bookingDetails.BookingID}</strong>
                        </p>

                    </div>

                    {/* Booking Details Card */}
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-light">
                            <h5 className="mb-0">Current Booking Details</h5>
                        </div>
                        <div className="card-body">
                            <h4 className="card-title mb-3">{bookingDetails.CustomerName}</h4>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <p className="mb-1 text-muted"><i className="bi bi-envelope-fill me-2"></i>Email</p>
                                    <p className="fw-bold">{bookingDetails.EmailID}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="mb-1 text-muted"><i className="bi bi-telephone-fill me-2"></i>Mobile</p>
                                    <p className="fw-bold">{bookingDetails.MobileNo}</p>
                                </div>

                                <div className="col-12"><hr className="my-2" /></div>

                                <div className="col-md-6">
                                    <p className="mb-1 text-muted"><i className="bi bi-calendar-check-fill me-2"></i>Check-in <span style={{ fontWeight: '600' }}>(Previous)</span> </p>
                                    <p className="fw-bold">{bookingDetails.CheckinDate} at {bookingDetails.CheckinTime}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="mb-1 text-muted"><i className="bi bi-calendar-x-fill me-2"></i>Check-out</p>
                                    <p className="fw-bold">{bookingDetails.CheckOutDate}</p>
                                </div>

                                <div className="col-12"><hr className="my-2" /></div>

                                <div className="col-md-6">
                                    <p className="mb-1 text-muted"><i className="bi bi-door-open-fill me-2"></i>Room Type</p>
                                    <p className="fw-bold">{bookingDetails.RoomTypeName} (Room No: {bookingDetails.RoomNo})</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="mb-1 text-muted"><i className="bi bi-people-fill me-2"></i>Guests</p>
                                    <p className="fw-bold">
                                        Adults: {bookingDetails.NoOfAdult},
                                        Children: {bookingDetails.NoOfChild}
                                        <span className="ms-2 fst-italic text-muted small">(Extra Person Allowed: {bookingDetails.AllowedExtraPerson})</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button className="btn btn-primary" onClick={checkAccomodation} disabled={loading}>
                            {loading ? "Checking..." : "Check Availability"}
                        </button>

                        {rescheduleAllowed !== null && (
                            <span style={{ marginLeft: "10px", fontWeight: "bold", color: rescheduleAllowed ? "green" : "red" }}>
                                {checkMessage}
                            </span>
                        )}

                        {rescheduleAllowed && (
                            <button
                                className="btn btn-success float-end"
                                style={{ marginLeft: "10px" }}
                                onClick={handleSubmitReschedule}
                                disabled={submitting || rescheduleSubmitted}
                            >
                                {submitting ? "Submitting..." : rescheduleSubmitted ? "Submitted" : "Submit Reschedule"}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReschedulePage;
